import type { ReactNode } from 'react';

import { cn } from '../utils/entry.js';

type CouponRowHeaderProps = {
  systemText: string;
  price: number;
  shouldShowPrice: boolean;
  isSelectedCouponIndex: boolean;
};

/**
 * Component that renders the header for each coupon row.
 *
 * @param root0 props for the component
 * @param root0.systemText text to display in the header
 * @param root0.price price to display in the header
 * @param root0.shouldShowPrice flag to determine if the price should be displayed
 * @param root0.isSelectedCouponIndex flag to determine if the coupon index is the currently selected one
 * @returns component that renders the header for each coupon row
 */
export default function CouponRowHeader({
  systemText,
  price,
  shouldShowPrice,
  isSelectedCouponIndex,
}: CouponRowHeaderProps): ReactNode {
  return (
    <div
      className={cn(`grid items-center justify-start font-medium`, !isSelectedCouponIndex && 'text-surface-fg-muted')}
    >
      <span>{systemText}</span>
      {shouldShowPrice && <span>{price} kr</span>}
    </div>
  );
}
